import { render } from "./actionModal.vue?vue&type=template&id=5be6a481&scoped=true&ts=true"
import script from "./actionModal.vue?vue&type=script&lang=ts"
export * from "./actionModal.vue?vue&type=script&lang=ts"

import "./actionModal.vue?vue&type=style&index=0&id=5be6a481&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be6a481"]])

export default __exports__